import * as React from 'react';
import { RouteComponentProps, StaticContext } from 'react-router';
import { AppLayoutBlank, AppError, Button } from '@mc/ui-v4';

type Props = RouteComponentProps<{}, StaticContext, {}>;

export const NotFoundPage: React.FC<Props> = ({ history }) => {
  return (
    <AppLayoutBlank horizontalCenter verticalCenter>
      <AppError message={'Stránka nenalezena'}>
        <Button
          className={'mt-2'}
          style={'primary'}
          onClick={() => {
            history.replace('/');
          }}
        >
          Přejít na úvodní stránku
        </Button>
      </AppError>
    </AppLayoutBlank>
  );
};
